import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import { environment } from "pstat-anywhere/relay";

const mutation = graphql`
  mutation ProxyLoginMutation($user: Int!) {
    proxyLogin(user: $user) {
      ok
      reasons
    }
  }
`;

export const doProxyLogin = userPk => {
  const variables = {
    user: userPk
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      const { ok } = response.proxyLogin;
      if (ok) {
        window.location.reload(true);
      }
    },
    onError: err => {
      if (err) {
        throw new Error(err);
      }
    }
  });
};
